import { Action } from '@reduxjs/toolkit'
import { usersRepository, usersStore } from '@entities/user'
import { of, filter, Observable, from, concat } from 'rxjs'
import { catchError, mergeMap, debounceTime } from 'rxjs/operators'
import { registerEpic } from '@shared/lib/redux'

const getUsersListEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(usersStore.actions.getUsersStart.match),
    debounceTime(500),
    mergeMap((action) =>
      from(usersRepository.getUsers(action.payload)).pipe(
        mergeMap((session) =>
          concat(of(usersStore.actions.getUsersSuccess(session)))
        ),
        catchError((error) =>
          of(usersStore.actions.getUsersFailure(error as string))
        )
      )
    )
  )

registerEpic(getUsersListEpic)
